import { render, staticRenderFns } from "./AcceptHosted.vue?vue&type=template&id=7ca552dc&"
import script from "./AcceptHosted.vue?vue&type=script&lang=js&"
export * from "./AcceptHosted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports